export class APPROVAL {
  //USER
  static ACCEPT = "ACCEPT";
  static REJECT = "REJECT";
  static PENDING = "PENDING";
}

export class USER_TYPE {
  //USER
  static MASTER_ADMIN = "MASTER-ADMIN";
  static JAMAT_ADMIN = "JAMAT-ADMIN";
  static NEWS_ADMIN = "NEWS-ADMIN";
  static STORIES_ADMIN = "STORIES-ADMIN";
  static MEMBER = "MEMBER";
  static EVENT_ADMIN="EVENT-ADMIN"

  static getUserTypes = () => {
    return [
      this.MASTER_ADMIN,
      this.JAMAT_ADMIN,
      this.NEWS_ADMIN,
      this.STORIES_ADMIN,
      this.EVENT_ADMIN,
    ];
  };

  static getJamatAdminUserTypes = () => {
    return [this.JAMAT_ADMIN, this.NEWS_ADMIN, this.STORIES_ADMIN,this.EVENT_ADMIN];
  };

  static getOtherUserTypes = (userTypes) => {
    return this.getUserTypes().filter((u) => !userTypes.includes(u));
  };

  static getUserTypesLower = (userType) => {
    return this.getUserTypes().filter(
      (u, i) => this.getUserTypes().indexOf(userType) < i
    );
  };

  static getUserTypesHigher = (userType) => {
    return this.getUserTypes().filter(
      (u, i) => this.getUserTypes().indexOf(userType) > i
    );
  };
}
